import BarChartIcon from '@mui/icons-material/BarChart'
import BoltIcon from '@mui/icons-material/Bolt'
import CampaignIcon from '@mui/icons-material/Campaign'
import DashboardIcon from '@mui/icons-material/Dashboard'
import Inventory2Icon from '@mui/icons-material/Inventory2'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import ReceiptIcon from '@mui/icons-material/Receipt'
import SettingsIcon from '@mui/icons-material/Settings'
import { routeBackOfficeAllEntityAdminCommon } from '@/lib/routes/backoffice/common/routeBackOfficeAllEntityAdminCommon'
import { MENU_GROUPS } from '@/lib/routes/menuGroups'
import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'

/**
 * Routes backoffice du Store PLV (StoreBag) — pages `/backoffice/store-bag/*`.
 * Entite PHARMEDISTOREBAG (section « Ma PLV ») : a NE PAS confondre avec la centrale
 * d'achat CS-Cart, portee par {@link getBackOfficeStoreCscartAdmin} (PHARMEDISTORE).
 * Ces routes ont longtemps ete declarees en PHARMEDISTORE, ce qui fusionnait les deux
 * modules dans une seule section de menu.
 */
const getBackOfficeStoreBagAdmin = [
  {
    route: 'Dashboard',
    text: 'Tableau de bord de pilotage',
    t: 'routes.backoffice.storeBag.dashboard',
    icon: DashboardIcon,
    href: '/backoffice/store-bag/dashboard',
    menuHeader: true,
    position: 10,
  },
  {
    route: 'AdminStoreBagProduct',
    text: 'Produits',
    icon: Inventory2Icon,
    href: '/backoffice/store-bag/product/product-list',
    menuHeader: true,
    position: 60,
  },
  {
    route: 'AddProduct',
    text: 'Créer un produit',
    href: '/backoffice/store-bag/product/add-product',
    menuHeader: false,
  },
  {
    route: 'EditProduct',
    text: 'Editer un produit',
    href: '/backoffice/store-bag/product/edit-product/[productId]',
    menuHeader: false,
  },
  {
    route: 'AdminStoreBagProgramme',
    text: 'Programmes',
    icon: CampaignIcon,
    href: `/backoffice/store-bag/program/program-list`,
    menuHeader: true,
    position: 40,
    isMobile: true,
  },
  {
    route: 'AdminStoreBagGestionFinance',
    text: 'Gestion financière',
    icon: ReceiptIcon,
    href: '/backoffice/store-bag/finance',
    menuHeader: true,
    position: 50,
  },
  {
    // Pilotage des commandes automatiques par PHARMACIE (une ligne par CIP, toutes campagnes
    // confondues) — complementaire de l'onglet participants, qui reste par programme.
    route: 'StoreBagAutoOrderList',
    text: 'Commandes automatiques',
    t: 'routes.backoffice.storeBag.autoOrders',
    icon: BoltIcon,
    href: '/backoffice/store-bag/auto-order/list',
    menuHeader: true,
    position: 52,
  },
  {
    // Alias du tableau de bord de pilotage PLV, hors menu : cible de l'action à faire PLV
    // (`StoreBagCapacityRiskActionCollector`, `?risk=over|watch` ouvre la tuile). « Dashboard »
    // est un nom partagé entre les modules, que getRoutes résout dans l'entité AFFICHÉE : lue
    // depuis l'espace radio, l'action menait au tableau de bord Sound. Remplace la page
    // « Capacité de distribution » (06/10/2026), dont la liste vit dans les tuiles.
    route: 'StoreBagPilotDashboard',
    text: 'Tableau de bord de pilotage',
    t: 'routes.backoffice.storeBag.dashboard',
    href: '/backoffice/store-bag/dashboard',
    menuHeader: false,
  },
  {
    route: 'StoreBagDeliveryList',
    text: 'Liste de livraisons',
    icon: LocalShippingIcon,
    href: '/backoffice/store-bag/delivery/list',
    menuHeader: true,
    position: 55,
  },
  {
    route: 'StatProgramStoreBag',
    text: 'Statistiques programmes',
    icon: BarChartIcon,
    href: '/backoffice/store-bag/program/stat-program',
    menuHeader: true,
    position: 60,
  },
  {
    route: 'AddProgramBag',
    text: 'Ajouter un programme',
    href: '/backoffice/store-bag/program/add-programme',
    menuHeader: false,
  },

  {
    route: 'EditProgramBag',
    text: 'Editer un programme',
    href: '/backoffice/store-bag/program/edit-program/[programId]',
    menuHeader: false,
  },

  {
    route: 'Settings',
    menuGroup: MENU_GROUPS.TOOLS,
    text: 'Paramétrage',
    icon: SettingsIcon,
    href: '/backoffice/common/settings',
    menuHeader: true,
    position: 310,
  },
  {
    route: 'AddDocument',
    text: 'Ajouter un document',
    href: '/backoffice/common/document/add-document',
    menuHeader: false,
  },
  {
    route: 'EditDocument',
    text: 'Editer un document',
    href: '/backoffice/common/document/edit-document/[documentId]',
    menuHeader: false,
  },
  {
    route: 'FilterFinance',
    text: 'Export des factures pharmaciens',
    href: '/backoffice/[entity]/finance/export-filter',
  },
  {
    route: 'HistoFinancial',
    text: 'Centre des exports',
    href: '/backoffice/[entity]/finance/export-history',
  },
  ...routeBackOfficeAllEntityAdminCommon,
].map(route => ({
  ...route,
  entity: [EntityList.PHARMEDISTOREBAG],
  roles: [CONSTANTS.ROLE_DYNAMIC_ROUTE_PLV_ADMIN],
}))

export default getBackOfficeStoreBagAdmin
